module.exports = __webpack_public_path__ + "img/chile-logo-icon.a168aba2.png";